export default {
  schedulesList(state) {
    return state.schedulesList;
  },
  currentSchedule(state) {
    return state.currentSchedule;
  },
  currentWeek(state) {
    // determine current week based on last winner in the current schedule

    const nextgame = state.currentSchedule.filter((game) => {
      return ( game.winner !== null && game.winner !== "" )
    });

    if ( nextgame.length > 0 ) {
      return nextgame[nextgame.length - 1].weekNumber;
    } else {
      return 0;
    }
  },
  nextWeek(state) {
    // determine next week based on first missing winner in the current schedule

    const nextgame = state.currentSchedule.filter((game) => {
      return ( game.winner === null || game.winner === "" )
    });

    if ( nextgame.length > 0 ) {
      return nextgame[0].weekNumber;
    } else {
      return 0;
    }
  },
}